import { IS_EYEJACK_APP } from "../utils/utils";
import VibrateBase from "./vibrate.base";
import VibrateApp from "./vibrate.app";
import VibrateWeb from "./vibrate.web";

export default class Vibrate extends VibrateBase {
  private impl: VibrateBase;
  
  constructor() {
    super();

    if( IS_EYEJACK_APP ) {
      this.impl = new VibrateApp();
    } else {
      this.impl = new VibrateWeb();
    }    
  }

  public override async vibrate(_pattern: number | number[]): Promise<boolean> {
    return this.impl.vibrate(_pattern);
  }
}

const _vibrate = new Vibrate();
export async function vibrate(_pattern: number | number[]): Promise<boolean> {
  return _vibrate.vibrate(_pattern);
}